export default __webpack_public_path__ + "static/media/IssacShapira.68090887.png";